//
//Base resource for retrieve data
//
//const baseUrl = "http://192.168.0.14:5000/api";
//const baseUrl = "http://localhost:5000/api";
//const baseUrl = "https://server.fujisushi.no/api";
const baseUrl = "https://testserver.fujisushi.no/api";
//
//Resource for authorization and authentication
//
//const loginUrl = 'http://192.168.0.14:5000/auth';
//const loginUrl = 'http://localhost:5000/auth';
//const loginUrl = 'https://etakeawayprod.azurewebsites.net/auth';
const loginUrl = 'https://testserver.fujisushi.no/auth';

//const orderMessagesUrl = 'http://192.168.0.14:5000/ordermessages';
//const orderMessagesUrl = 'http://localhost:5000/ordermessages';
//const orderMessagesUrl = 'https://etakeawayprod.azurewebsites.net/ordermessages';
const orderMessagesUrl = 'https://etakeawaystage.azurewebsites.net/ordermessages';

//
//Resource for retrieve restaurant owner profile (must include restaurant owner id)
//

const restaurantOwnerProfilesUrl = `${baseUrl}/restaurantownerprofiles`;
//
//Resource for retrieve restaurants resource (must include restaurant owner id)
//
const restaurantsUrl = `${baseUrl}/restaurants`;
//
//Resource for retrieve openingtime from resource (must include restaurant id)
//
const openingTimeTableUrl = `${baseUrl}/openingtimetables`;

//
//Resource for retrieve pickup number from resource (must include restaurant id)
//
const pickupNumbersUrl = `${baseUrl}/pickupnumbers`;

//
//Resource for retrieve current waiting times from resource (must include restaurant id)
//
const waitingTimesUrl = `${baseUrl}/waitingtimes`;

//
//Resource for retrieve categories resource (must include restaurant id)
// 
const categoriesUrl = `${baseUrl}/categories`;
//
//Resource for retrieve categories resource (must include restaurant id)
// 
const itemsUrl = `${baseUrl}/items`;
//
//Resource for retrieve images resource (must include restaurant id)
// 
const imagesUrl = `${baseUrl}/images`;
//
//Resource for retrieve categories resource (must include restaurant id)
// 
const menusUrl = `${baseUrl}/menus`;
//
//Resource for retrieve categories resource (must include restaurant id)
// 
const menuItemsUrl = `${baseUrl}/menuitems`;
//
//Resource for retrieve categories resource (must include restaurant id)
// 
const ordersUrl = `${baseUrl}/orders`;

const restaurantsTotalUrl = `${baseUrl}/orders`;
//
//Resource for retrieve restaurant types
// 
const restaurantTypesUrl = `${baseUrl}/restauranttypes`;
//
//Resource for retrieve taxes
// 
const taxesUrl = `${baseUrl}/taxes`;

//
//Resource for retrieve taxes
// 
const printersUrl = `${baseUrl}/printers`;

//
//Resource for payment subscription
//
const paymentSubscriptionUrl = `${baseUrl}/paymentsubscription`;

const orderByPhonesUrl = `${baseUrl}/orderbyphone`;

const receiptUrl = `${baseUrl}/receiptreport/sendreceipttoemailbyorderid`;

export {
    baseUrl,
    loginUrl,
    restaurantOwnerProfilesUrl,
    restaurantsUrl,
    categoriesUrl,
    openingTimeTableUrl,
    itemsUrl,
    menusUrl,
    menuItemsUrl,
    imagesUrl,
    ordersUrl,
    restaurantsTotalUrl,
    restaurantTypesUrl,
    taxesUrl,
    printersUrl,
    orderMessagesUrl,
    waitingTimesUrl,
    paymentSubscriptionUrl,
    pickupNumbersUrl,
    orderByPhonesUrl,
    receiptUrl
}